export default __webpack_public_path__ + "static/media/user.88289b15.svg";